import { useCallback, useEffect, useState } from 'react';
import { fetchAssetCollection, hasContentfulConfig } from '../lib/contentfulClient';
import { useSiteContent } from '../context/SiteContentContext';

/**
 * Lazily fetches Contentful assets by title prefix.
 * @param {string} prefix - Asset title prefix (e.g. 'netshape/')
 * @param {string} collectionKey - Key to store in context
 * @param {{ immediate?: boolean }} [options]
 */
export function useContentfulAssets(prefix, collectionKey, { immediate = true } = {}) {
  const { updateCollection } = useSiteContent();
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    if (!hasContentfulConfig()) return;
    setIsLoading(true);
    try {
      const result = await fetchAssetCollection(prefix);
      setItems(result);
      if (collectionKey) updateCollection(collectionKey, result);
    } catch (err) {
      console.error(`[useContentfulAssets] Failed to load "${prefix}":`, err);
    } finally {
      setIsLoading(false);
    }
  }, [prefix, collectionKey, updateCollection]);

  useEffect(() => { if (immediate) load(); }, [load, immediate]);

  return { items, isLoading };
}
